import React, { useRef, useEffect, useState } from 'react';
import './AboutUs.css';
import promoImage from '../assets/aboutus_new.jpeg';
import goals from '../assets/goals1.jpg';
import Footer from '../pages/Footer';
import FloatingOrderButton from '../components/FloatingOrderButton';
import { FaChevronLeft, FaChevronRight, FaStore, FaUsers, FaClock, FaLeaf, FaBolt, FaShieldAlt, FaAward, FaHandshake, FaGlobe, FaHeart, FaStar, FaTruck } from 'react-icons/fa';
import api from './api';
import { useAppSelector } from '../store/hooks';

// const teamMembers = [
//   { img: person1, name: 'Rahul Sharma', role: 'Founder & CEO', desc: 'Built the company from scratch with a vision to bring innovation and trust to the laundry space.' },
//   { img: person2, name: 'Neha Verma', role: 'Operations Head', desc: 'Heads our nationwide operations ensuring excellence in service and customer satisfaction.' },
//   { img: person3, name: 'Amit Mehra', role: 'Marketing Lead', desc: 'Leads marketing efforts with a focus on growth, customer loyalty and digital strategy.' },
//   { img: person3, name: 'Sneha Kapoor', role: 'Customer Success', desc: 'Drives customer delight by building long-lasting service experiences and satisfaction.' },
//   { img: person3, name: 'Varun Sinha', role: 'Tech Lead', desc: 'Architects our backend with scalable, resilient systems and modern tech stacks.' }
// ];

export default function AboutUs() {
  const stats = useAppSelector((state) => state.stats);
  const [teamMembers, setTeamMembers] = useState([]);

  useEffect(() => {
    // Fetch team data from API
    api.get('/getTeam')
    .then((res) => {
      if (res?.data?.data) {
        setTeamMembers(res.data.data);
      }
    })
      .catch(error => {
        console.error("Error fetching team members:", error);
      });
      console.log(teamMembers)
  }, []);

    const scrollRef = useRef();
  
    const scrollLeft = () => {
      scrollRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    };
  
    const scrollRight = () => {
      scrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    };

  return (
    <div className="about-page">
      <div className="about-hero">
        <h1 className='about-heading'>About Us</h1>
        <p className='about-para'>Be a part of India's fastest growing dry-cleaning brand. Low investment, high return, full support.</p>
      </div>

      <div className="about-highlight">
        <div className="highlight-left">
          <img src={promoImage} alt="Laundry Highlight" className="highlight-image" />
        </div>
        <div className="highlight-right">
          <h2>LAUNDRY BELONGS IN A LAUNDROMAT</h2>
          <p className="subtext">An average human spends between 12000 hours of their adult life in cleaning and managing their clothes. We have all grown up on a heavy dose of detergent commercials propagating the idea of ‘whiter the better’.</p>
          <p>But none of these commercials talked about the hours of hard work required to get that blinding whiteness. Do the words ‘enzyme soak’, hot water cleaning’, ‘bluing’ ring a bell? How we wish maintaining our white clothes was easy as watching those commercials. With us, <span className="highlight">it is Easier!</span></p>
          <p>We bring the best-in-class Laundry, Dry Cleaning and Home Cleaning Services at your doorstep!</p>
          <p>We operate a network of {stats.storeCount}+ stores across {stats.cityCount} cities, making <span className="highlight">it the Largest Laundry & Dry-Cleaning Chain in India.</span> Our nearest store offers live laundry, steam ironing and dry-cleaning services, with free home pick & drop, and a promise to deliver your clothes in less than 24 hours*.</p>
        </div>
      </div>

      <h2 className="aboutus">Our Team Members</h2>
      <p className="swipe-instruction">Swipe right to see more &rarr;</p>
      <div className="team-card-wrapper">
        <button className="scroll-btn left" onClick={scrollLeft} aria-label="Scroll left"><FaChevronLeft /></button>
        <div className="team-card-container" ref={scrollRef}>
          {teamMembers.map((member, idx) => (
            <div key={idx} className="team-card">
              <img src={member.img} alt={member.name} className="team-card-image" />
              <div className="team-card-info">
                <h3>{member.name}</h3>
                <h4>{member.title}</h4>
                <p>{member.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <button className="scroll-btn right" onClick={scrollRight} aria-label="Scroll right"><FaChevronRight /></button>
      </div>
        <div className="about-highlight">
        <div className="highlight-left">
          <img src={goals} alt="Laundry Highlight" className="highlight-image" />
        </div>
        <div className="highlight-right">
          <h2>Our Team Goals</h2>
          <p className="subtext"><span className="highlight">Less time doing laundry. More time living life.</span></p>
          <p>We believe laundry shouldn't steal your hours or energy. Our mission is to make fabric care effortless, giving you back the <span className="highlight">time you deserve!</span>.</p>
          <p>Every piece of clothing we handle gets expert attention — whether it's your go-to shirt or a delicate dress. We care for it like it’s our own.</p>
          <p>With smart processes, fast delivery, and a team that truly cares, we’re reimagining laundry — to be <span className="highlight">faster, greener, and worry-free.</span></p>
        </div>
      </div>

      {/* Stats Section */}
      <section className="stats-section_4">
        <div className="stats-grid_4">
          <div className="stat-card_4">
            <div className="stat-icon_4" aria-hidden="true"><FaStore /></div>
            <h3>{stats.storeCount}+ Stores</h3>
            <p>Growing nationwide with reliable, local service.</p>
          </div>
          <div className="stat-card_4">
            <div className="stat-icon_4" aria-hidden="true"><FaUsers /></div>
            <h3>{stats.customerCount.toLocaleString()}+ Customers</h3>
            <p>Trusted by households and professionals alike.</p>
          </div>
          <div className="stat-card_4">
            <div className="stat-icon_4" aria-hidden="true"><FaClock /></div>
            <h3>24h Turnaround</h3>
            <p>Fast delivery without compromising care.</p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <h2 className="section-title">What We Stand For</h2>
        <div className="values-grid">
          <div className="value-card">
            <div className="value-icon" aria-hidden="true"><FaShieldAlt /></div>
            <h3>Quality & Care</h3>
            <p>Fabric-safe methods, expert handling, and rigorous checks for every order.</p>
          </div>
          <div className="value-card">
            <div className="value-icon" aria-hidden="true"><FaBolt /></div>
            <h3>Speed & Reliability</h3>
            <p>Consistent, on-time delivery with clear communication at every step.</p>
          </div>
          <div className="value-card">
            <div className="value-icon" aria-hidden="true"><FaLeaf /></div>
            <h3>Eco Mindset</h3>
            <p>Lower-impact solvents and processes designed to reduce waste.</p>
          </div>
        </div>
      </section>

      {/* Company Timeline Section */}
      <section className="company-timeline">
        <h2 className="section-title">Our Journey</h2>
        <div className="timeline-container">
          <div className="timeline-item">
            <div className="timeline-year">2025</div>
            <div className="timeline-content">
              <h3>Founded</h3>
              <p>Started with a vision to revolutionize laundry services in India.</p>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-year">2025</div>
            <div className="timeline-content">
              <h3>Expansion</h3>
              <p>Reached {stats.cityCount} cities with our reliable laundry services.</p>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-year">2025</div>
            <div className="timeline-content">
              <h3>Innovation</h3>
              <p>Launched eco-friendly cleaning processes and digital platform.</p>
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-year">2025</div>
            <div className="timeline-content">
              <h3>Growth</h3>
              <p>Now serving {stats.customerCount.toLocaleString()}+ customers across {stats.storeCount} locations.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Awards & Recognition Section */}
      <section className="awards-section">
        <h2 className="section-title">Awards & Recognition</h2>
        <div className="awards-grid">
          <div className="award-card">
            <div className="award-icon"><FaAward /></div>
            <h3>Best Laundry Service 2025</h3>
            <p>Recognized by Indian Business Excellence Awards</p>
          </div>
          <div className="award-card">
            <div className="award-icon"><FaStar /></div>
            <h3>Customer Choice Award</h3>
            <p>Highest rated laundry service in customer satisfaction</p>
          </div>
          <div className="award-card">
            <div className="award-icon"><FaHandshake /></div>
            <h3>Franchise Excellence</h3>
            <p>Best franchise opportunity in home services category</p>
          </div>
          <div className="award-card">
            <div className="award-icon"><FaGlobe /></div>
            <h3>Green Business Award</h3>
            <p>Recognized for sustainable and eco-friendly practices</p>
          </div>
        </div>
      </section>

      {/* Community Impact Section */}
      <section className="community-impact">
        <h2 className="section-title">Our Community Impact</h2>
        <div className="impact-grid">
          <div className="impact-card">
            <div className="impact-icon"><FaHeart /></div>
            <h3>Community Support</h3>
            <p>Supporting local communities through employment opportunities and sustainable practices.</p>
          </div>
          <div className="impact-card">
            <div className="impact-icon"><FaLeaf /></div>
            <h3>Environmental Care</h3>
            <p>Reducing water consumption by 40% and using biodegradable detergents.</p>
          </div>
          <div className="impact-card">
            <div className="impact-icon"><FaTruck /></div>
            <h3>Accessibility</h3>
            <p>Making quality laundry services accessible to all income groups.</p>
          </div>
        </div>
      </section>

      {/* CTA band */}
      <section className="about-cta">
        <h3>Experience fabric care that fits your life</h3>
        <p>Schedule a pickup today and let us handle the rest.</p>
      </section>
        <Footer />
        <FloatingOrderButton />
    </div>
  );
}
